import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return <footer className='main-footer'></footer>
  }
}
